module.exports = __webpack_public_path__ + "static/img/merchant_feature_9.f043972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_9.png
// module id = aAiU
// module chunks = 8